import { COLORS } from '@/constants';
import { FormControlLabel } from '@mui/material';
import styled from 'styled-components';

export const StyledFormControlLabel = styled(FormControlLabel)`
  & .MuiRadio-root {
    color: black;
    padding: 0;

    .MuiSvgIcon-fontSizeMedium {
      width: 12px;
      height: 12px;
      padding-right: 10px;
      color: black;
    }
  }

  & .MuiFormControlLabel-label {
    font-size: 18px;
    font-weight: 400;

    @media (max-width: 700px) {
      font-size: 12px;
      font-weight: 300;
    }
  }
`;

export const StyledCountData = styled.span`
  font-size: 10px;
  border: 1px solid ${COLORS['brown/400']};
  padding: 0 4px;
  border-radius: 10px;
  text-align: center;
  width: fit-content;

  @media (max-width: 700px) {
    font-size: 14px;
    font-weight: 300;
    line-height: 21px;
  }
`;

export const ControlLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 26px;
  width: 100%;
`;
